import React from 'react';
import useIntl from 'react-intl/src/components/useIntl';
import type { MessageDescriptor } from 'react-intl';
import { Button } from 'semantic-ui-react';
import StoredAccordion from 'src/components/StoredAccordion';
import messages from 'src/messages';
import { CustomFieldsTable } from './CustomFieldsTable';
import './CustomFieldCategorySection.module.css';

/** One collapsible category of custom fields, with its own add button. */
export function CustomFieldCategorySection({
  category,
  label,
  fields,
  permissionWrite,
  onCreate,
  onEdit,
  onDelete,
}: {
  category: string;
  label: MessageDescriptor;
  fields: any[];
  permissionWrite: boolean;
  onCreate: () => void;
  onEdit: (field: any) => void;
  onDelete: (field: any) => void;
}) {
  const { formatMessage } = useIntl();

  return (
    <StoredAccordion
      name={`custom_fields_${category}`}
      title={formatMessage(label)}
    >
      <div className="custom-field-category-actions">
        <Button
          size="mini"
          icon="add"
          content={formatMessage(messages.customFieldNew)}
          disabled={!permissionWrite}
          onClick={onCreate}
        />
      </div>
      <CustomFieldsTable
        fields={fields}
        permissionWrite={permissionWrite}
        onEdit={onEdit}
        onDelete={onDelete}
      />
    </StoredAccordion>
  );
}
